var exports = {
  "zr": "xa15a2ab7--eb1e02--root",
  "my": "xa15a2ab7--eb1e02--avatar",
  "J2": "xa15a2ab7--eb1e02--avatar-none",
  "pq": "xa15a2ab7--eb1e02--info",
  "DD": "xa15a2ab7--eb1e02--title",
  "UU": "xa15a2ab7--eb1e02--name",
  "tD": "xa15a2ab7--eb1e02--account-type",
  "Kk": "xa15a2ab7--eb1e02--icon",
};

module.exports = exports;
